<template>
	<div>
		<h6>e-Boekhouden</h6>
		<div v-if="order.eboekhoud && order.eboekhoud.invoice_send">
			<vs-row class="mt-5">
				<vs-col class="w-1/3">
					<vx-tooltip text="Factuur reeds verzonden" position="top">
						<vs-button class="vs-button-success">
							<font-awesome-icon :icon="['fas', 'paper-plane']" />
						</vs-button>
					</vx-tooltip>
				</vs-col>
				<vs-col class="w-1/3">
					<vx-tooltip text="Download factuur" position="top">
						<vs-button id="printEboekhoudInvoiceButton" @click.native="downloadEboekhoudInvoice()">
							<font-awesome-icon :icon="['fas', 'print']" />
						</vs-button>
					</vx-tooltip>
				</vs-col>
			</vs-row>
		</div>
		<div v-if="!order.eboekhoud || !order.eboekhoud.invoice_send">
			<vs-row class="mt-5">
				<vs-col class="w-1/3">
					<vx-tooltip text="Vertuur factuur">
						<vs-button id="sendEboekhoudInvoiceButton" @click.native="sendEboekhoudInvoice()">
							<font-awesome-icon :icon="['fas', 'paper-plane']" />
						</vs-button>
					</vx-tooltip>
				</vs-col>
				<vs-col class="w-1/3">
					<vs-button disabled>
						<font-awesome-icon :icon="['fas', 'print']" />
					</vs-button>
				</vs-col>
			</vs-row>
		</div>
	</div>
</template>

<script>
import apiClient from '@/services/apiClient';
import {mapGetters} from 'vuex';
import {format} from 'date-fns';

export default {

	props: {
		order: {
			required: true,
		}
	},
	computed: {
		...mapGetters({
			isEboekhoudenEnabled: 'dashboard/eboekhoudenEnabled'
		}),
	},
	methods: {
		sendEboekhoudInvoice() {
			this.startSendLoading()

			const params = {
				'order_id': this.order.order.id,
				'type': 'eboekhouden'
			}

			apiClient.post('orders/invoice/send', params).then(response => {
				const cloneOrder = JSON.parse(JSON.stringify(this.order));

				cloneOrder.eboekhoud = {
					invoice_send: true
				};

				this.order = cloneOrder;

				this.stopSendLoading()
			}).catch(error => {
				this.stopSendLoading()
				console.log(error)
			});
		},

		downloadEboekhoudInvoice() {
			this.startPrintLoading();

			const params = {
				'order_id': this.order.order.id,
				'type': 'eboekhouden'
			}

			apiClient.get('orders/invoice/download', {
				params,
				responseType: 'blob'
			}).then(response => {

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;

				link.setAttribute('download', this.order.order.type_id_visible + ' - ' + format(new Date(), 'Y-MM-dd_H:mm:ss') + '.pdf');
				document.body.appendChild(link);
				link.click();

				this.stopPrintLoading();
			}).catch(error => {
				this.stopPrintLoading()
				console.log(error)
			});
		},

		startSendLoading() {
			this.$vs.loading({
				container: '#sendEboekhoudInvoiceButton',
				scale: 0.45
			})
		},
		stopSendLoading() {
			this.$vs.loading.close('#sendEboekhoudInvoiceButton > .con-vs-loading')
		},
		startPrintLoading() {
			this.$vs.loading({
				container: '#printEboekhoudInvoiceButton',
				scale: 0.45
			})
		},
		stopPrintLoading() {
			this.$vs.loading.close('#printEboekhoudInvoiceButton > .con-vs-loading')
		}

	}
}
</script>
